import { RuntimeDate } from '@edgebox/data-definition-kit';

/** A date of a Brand Presence list, read to the minute: `Sep 27, 15:23`, and a dash when there is none. */
export function formatDate(date?: RuntimeDate): string {
  if (!date) {
    return '-';
  }

  return date.format('MMM DD, HH:mm');
}
